import { createBrowserRouter } from "react-router-dom";
import MainLayout from "./MainCompontent/App";
import AdminLayout from "./Admin/AdminLayout";

import Homepage from "./Homepage";
import AboutPage from "./Page/AboutPage";
import Adminform from "./Admin/Adminform";
import Content from "./Page/Content";
import AdminView from "./Admin/AdminView";
import Admintestimonials from "./Admin/Admintestimonials";
import AdmintestimonialsView from "./Admin/AdmintestimonialsView";
import FeaturedAdmin from "./Admin/FeaturedAdmin";
import FeaturedViewAdmin from "./Admin/FeaturedViewAdmin";
import Testimonials from "./HomeCompontent/Testimonials";
import CourseDetail from "./HomeCompontent/CourseDetails";
import Subcatgory from "./Admin/Subcatgory";
import SubcatgoryView from "./Admin/Subcatgoryview";

import EnrollForm from "./Page/EnrollForm";
import TestimonialForm from "./Page/TestimonialForm";
import Courses from "./HomeCompontent/Courses";
import UserRegister from "./User/UserRegister";
import UserLogin from "./User/Userlogin";
import ForgetPassword from "./User/ForgetPassword";
import ResetPassword from "./User/ResetPassword";
import AdminDashboard from "./Admin/AdminDashboard";
import Adminpage from "./Admin/Adminpage";
import GalleryPage from "./Page/GalleryPage";
import CourseMore from "./Page/CourseMore";
import CourseMoreDisk from "./Admin/CourseMoreDisk";
import CourseMoreDiskView from "./Admin/CourseMoreDiskView";

const router = createBrowserRouter([
  {
    path: "/",
    element: <MainLayout />,
    children: [
      { index: true, element: <Homepage /> },
      { path: "about-us", element: <AboutPage /> },
      { path: "gallery", element: <GalleryPage /> },
      { path: "contact", element: <Content /> },
      { path: "testimonials", element: <Testimonials /> },
      { path: "/:titleSlug", element: <CourseDetail /> },
      { path: "/enroll", element: <EnrollForm /> },
      { path: "/testimonialForm", element: <TestimonialForm /> },
      { path: "/courses", element: <Courses /> },
      { path: "/user-register", element: <UserRegister /> },
      { path: "/user-login", element: <UserLogin /> },
      { path: "/forgot-password", element: <ForgetPassword /> },
      { path: "/reset-password/:token", element: <ResetPassword /> },
      { path: "/courses-more/:skill_detail_id", element: <CourseMore /> },
    ],
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      { index: true, element: <Adminpage /> },
      { path: "dashboard", element: <AdminDashboard /> },
      { path: "add-image", element: <Adminform /> },
      { path: "add-view", element: <AdminView /> },
      { path: "add-testimonials", element: <Admintestimonials /> },
      { path: "add-testimonialsView", element: <AdmintestimonialsView /> },
      { path: "add Course", element: <FeaturedAdmin /> },
      { path: "add CourseView", element: <FeaturedViewAdmin /> },
      { path: "add-subcategory", element: <Subcatgory /> },
      { path: "add-subcategoryview", element: <SubcatgoryView /> },
      { path: "add-SubcategoryMore", element: <CourseMoreDisk /> },
      { path: "add-SubcategoryMoreView", element: <CourseMoreDiskView /> },
    ],
  },
]);

export default router;
